import { ApiError, getMessage, request } from './client';

/**
 * Benchmark prices shown in the consumer onboarding savings calculator.
 * Always hits the real backend.
 *
 * Row shape: { id, fuelType, unit, stationPrice, pompiPrice, sizePerFillUp,
 *              priceDifference, savingsPerFillUp, updatedAt, source }
 */
export async function getOnboardingPrices() {
  const res = await request('admin/onboarding-prices');
  if (!Array.isArray(res?.Data)) throw new ApiError('Unexpected response from the server.', 200, res);
  return res.Data;
}

/** `values`: { stationPrice, pompiPrice, sizePerFillUp }. Resolves to `{ message, price }`. */
export async function updateOnboardingPrice(id, values) {
  const res = await request(`admin/onboarding-prices/${id}`, { method: 'PUT', body: values });
  if (!res?.Data) throw new ApiError('Unexpected response from the server.', 200, res);
  return { message: getMessage(res), price: res.Data };
}
